let editLockInterval = null
document.addEventListener('turbo:load', async () => {
  const showcaseDataElement = document.querySelector('.requires-edit-lock.d-none')
  if (showcaseDataElement){
    const showcaseData = showcaseDataElement.dataset
    editLockInterval = setInterval(async () => {
      fetch(`/showcases/${showcaseData.showcaseId}/update_edit_lock`, {
        method: "POST",
        keepalive: true,
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]') ? document.querySelector('meta[name="csrf-token"]').getAttribute('content') : ''
        }
      })
    }, 5 * 1000)
  }
})

document.addEventListener('turbo:before-cache', () => {
  if (editLockInterval) {
    clearInterval(editLockInterval)
    editLockInterval = null
  }
})
